import { useMemo } from 'react'
// routes
import { paths } from 'src/routes/paths'
// locales
// components
import Iconify from 'src/components/iconify'

// ----------------------------------------------------------------------

const icon = (name: string) => <Iconify icon={name} />

const ICONS = {
  user: icon('carbon:user-data'),
  dashboard: icon('carbon:dashboard'),
  products: icon('carbon:inventory-management'),
  reports: icon('carbon:report'),
  events: icon('carbon:calendar'),
  orders: icon('carbon:shopping-cart'),
  trash: icon('carbon:trash-can'),
  radar: icon('carbon:chart-multitype'),
  tasks: icon('carbon:task-approved'),
  chat: icon('carbon:chat'),
}

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      {
        subheader: 'Dashboard',
        items: [
          { title: 'Tarefas', path: paths.dashboard.tasks, icon: ICONS.tasks, permission: 'tasks' },
          { title: 'Usuários', path: paths.dashboard.user, icon: ICONS.user, permission: 'users' },
          { title: 'Clientes', path: paths.dashboard.clients, icon: ICONS.user, permission: 'clients' },
          { title: 'Pacotes', path: paths.dashboard.packages, icon: ICONS.reports, roles: ['admin'] },
          { title: 'Hospedagens', path: paths.dashboard.hostings, icon: ICONS.products, roles: ['admin'] },
          { title: 'Orçamentos', path: paths.dashboard.budgets.root, icon: ICONS.reports, permission: 'budgets' },
          { title: 'Orç. Hospedagem', path: paths.dashboard.hostingBudgets.root, icon: ICONS.orders, permission: 'hostingBudgets' },
          { title: 'CRM Kanban', path: paths.dashboard.kanban, icon: ICONS.events, permission: 'kanban' },
          { title: 'Relatórios', path: paths.dashboard.reports, icon: ICONS.reports, permission: 'reports' },
          // Link externo: abre o painel da Zenvia em nova aba (visível a todos).
          { title: 'Zenvia', path: 'https://app.zenvia.com/', icon: ICONS.chat },
        ],
      },
    ],
    [],
  )

  return data
}
